exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".submit[data-v-0657f773]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;flex-direction:column;align-items:center}.valid-message[data-v-0657f773]{margin-top:5px;color:#ff9790}", ""]);

// exports
